export default __webpack_public_path__ + "static/media/slide1.2bfd107e.jpeg";